import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { Box } from '@mui/material';

const TypingIndicator: React.FC = () => {
  return (
    <Box display="flex" alignItems="center">
      <Box display="flex" ml={1}>
        <CircleIcon className="dot first-dot" />
        <CircleIcon className="dot second-dot" />
        <CircleIcon className="dot third-dot" />
      </Box>

      <style>
        {`
          @keyframes blink {
            0%, 20% {
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }

          .dot {
            font-size: 0.8rem;
            margin-left: 3px;
            opacity: 0;
          }

          .first-dot {
            animation: blink 1.5s infinite 0s;
          }

          .second-dot {
            animation: blink 1.5s infinite 0.2s;
          }

          .third-dot {
            animation: blink 1.5s infinite 0.4s;
          }
        `}
      </style>
    </Box>
  );
};

export default TypingIndicator;
